import { RootState } from '../store';

export const isGoogleApiLoadedSelector = (state: RootState): boolean => state.googleApi.isGoogleApiLoaded;
